package one.healthium.db

import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import app.cash.sqldelight.driver.worker.WebWorkerDriver

internal actual class DriverFactory {
    actual suspend fun createDriver(schema: SqlSchema<QueryResult.AsyncValue<Unit>>): SqlDriver {
        val driver = WebWorkerDriver(
            app.cash.sqldelight.driver.worker.expected.Worker(
                "sqlite.worker.js"
            )
        )

        driver.execute(
            identifier = null,
            sql = "PRAGMA foreign_keys = ON",
            parameters = 0,
        ).await()

        val currentVersion = driver.executeQuery(
            identifier = null,
            sql = "PRAGMA user_version",
            mapper = ::mapUserVersion,
            parameters = 0,
        ).await()

        val hasApplicationTables = driver.executeQuery(
            identifier = null,
            sql = """
                SELECT EXISTS(
                    SELECT 1
                    FROM sqlite_master
                    WHERE type = 'table' AND name NOT LIKE 'sqlite_%'
                )
            """.trimIndent(),
            mapper = ::mapBoolean,
            parameters = 0,
        ).await()

        when {
            currentVersion == 0L && !hasApplicationTables -> {
                schema.create(driver).await()
                setUserVersion(driver, schema.version)
            }

            currentVersion == 0L && hasApplicationTables -> {
                setUserVersion(driver, schema.version)
            }

            currentVersion < schema.version -> {
                schema.migrate(driver, currentVersion, schema.version).await()
                setUserVersion(driver, schema.version)
            }
        }

        return driver
    }

    private suspend fun setUserVersion(driver: SqlDriver, version: Long) {
        driver.execute(
            identifier = null,
            sql = "PRAGMA user_version = $version",
            parameters = 0,
        ).await()
    }

    private fun mapBoolean(cursor: SqlCursor): QueryResult<Boolean> {
        return QueryResult.AsyncValue {
            if (cursor.next().await()) {
                cursor.getLong(0) == 1L
            } else {
                false
            }
        }
    }

    private fun mapUserVersion(cursor: SqlCursor): QueryResult<Long> {
        return QueryResult.AsyncValue {
            if (cursor.next().await()) {
                cursor.getLong(0) ?: 0L
            } else {
                0L
            }
        }
    }
}
